<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M17.76 2.81147C16.8447 1.89618 15.3607 1.89618 14.4454 2.81147L3.05037 14.2066C1.52488 15.7321 1.52488 18.2054 3.05036 19.7309C4.57585 21.2564 7.04915 21.2564 8.57464 19.7309L16.5882 11.7173C16.8933 11.4122 17.3879 11.4122 17.693 11.7173C17.9981 12.0224 17.9981 12.5171 17.693 12.8222L9.67949 20.8357C7.54381 22.9714 4.08119 22.9714 1.94551 20.8357C-0.19017 18.7001 -0.19017 15.2374 1.94551 13.1018L13.3406 1.70661C14.8661 0.181129 17.3394 0.181128 18.8648 1.70661C20.3903 3.2321 20.3903 5.7054 18.8648 7.23088L7.4764 18.6193C7.47346 18.6223 7.47049 18.6253 7.46748 18.6283L7.46033 18.6354L7.45803 18.6377L7.45569 18.64C6.53921 19.5413 5.06582 19.5366 4.15522 18.626C3.23993 17.7107 3.23993 16.2268 4.15521 15.3115L12.2911 7.17534C12.5962 6.87024 13.0909 6.87023 13.396 7.17533C13.7011 7.48042 13.7011 7.97508 13.396 8.28018L5.26008 16.4163C4.95498 16.7214 4.95498 17.2161 5.26007 17.5212C5.56293 17.824 6.05267 17.8262 6.35816 17.5279L17.76 6.12603C18.6753 5.21074 18.6753 3.72676 17.76 2.81147Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgClip',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>